<template>

    <form ref="planoservico-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="nome">Nome</label>
                        <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="model.nome" required/>
                    </div>
					<div class="form-group col-md-12">
                        <label for="descricao">Descrição</label>
                        <textarea type="text" class="form-control" name="descricao" placeholder="Descrição" v-model="model.descricao" />
                    </div>
					<div class="form-group col-md-4">
                        <label for="valor">Valor</label>
                        <input type="text" class="form-control" name="valor" placeholder="Valor" v-model="model.valor" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="totalMeuCNA">Meu CNA</label>
                        <input type="text" class="form-control" name="totalMeuCNA" placeholder="Meu CNA" v-model="model.totalMeuCNA" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="totalSMS">SMS</label>
                        <input type="text" class="form-control" name="totalSMS" placeholder="SMS" v-model="model.totalSMS" required />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Ativo?</span>
                        </label>
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "planoservico-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "planoservico-form-create",
            
            resources: {
                create: 'planoservico',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

